"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePageUrls = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _url = require("../utils/url");
var _useSearchParams = require("./use-search-params");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Utils

// Hooks

/*
 * Generate a memoized list of page size urls. Chaning the page size will reset
 * the offset to zero to simplify things.
 */
const usePageUrls = ({
  total = 0,
  limit
}) => {
  const location = (0, _reactRouterDom.useLocation)();
  const [searchParams] = (0, _useSearchParams.useSearchParams)();
  // @ts-ignore
  const _limit = limit || searchParams.limit;
  return (0, _react.useMemo)(() => {
    const pageCount = Math.ceil(total / _limit);
    return (0, _url.buildUrlSet)(`${location.pathname}${location.search}`, 'offset',
    // @ts-ignore
    new Array(pageCount).fill(0).map((_, index) => index * _limit));
  }, [location.pathname, location.search, _limit, total]);
};
exports.usePageUrls = usePageUrls;